export class Tag {
    serialNumber: string;
    type: string;
    version: string;
    tagEd: boolean;
    docLang: string;
    adibib: boolean;
    pageInfo: PageTagInfo[];

    constructor() {
        this.pageInfo = [];
    }
}

export class PageTagInfo {
    id: number;
    rawPage: any;
    parsedPage: any;
    isParsed: boolean;
    isInProgress: boolean;
}
